import posthog from 'posthog-js';

let initialized = false;

export function initPostHog() {
  if (initialized) return;

  const token = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
  const apiHost = import.meta.env.VITE_POSTHOG_HOST;

  if (!token) return;

  posthog.init(token, {
    api_host: apiHost,
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
      recordCrossOriginIframes: true,
    },
  });

  initialized = true;
}

export { posthog };
